import React, {useContext, useEffect} from 'react';
import PropTypes from "prop-types";
import {LinesContext, UserContext} from '@web/hooks/context';
import {useDispatch, useSelector} from "react-redux";
// import contentActions from "@web/redux/content/actions";
import appActions from "@web/redux/app/actions";
import collectionsActions from '@web/redux/collections/actions';

ContactActivityData.propTypes = {
  path: PropTypes.string,
  children: PropTypes.node.isRequired,
};

function ContactActivityData({path, empty, children, ...props}) {
  const dispatch = useDispatch();
  const [userId] = useContext(UserContext);
  const ctx = React.useContext(LinesContext);
  // const activeServiceId = useSelector((state) => state.App.activeServiceId);

  const clearActiveDetail = React.useCallback(() => {
    dispatch(appActions.clearActiveDetail());
  }, []);

  const contact = useSelector((state) => {
    return state.Content?.data?.[path];
  });

  const activityList = useSelector((state) =>
    state.Content.activity?.[path]?.activityList);

  const itemsList = useSelector((state) =>
    state.Content.activity?.[path]?.itemsList);

  useEffect(() => {
    console.log(path);
    path &&
    dispatch(collectionsActions.fetch(ctx.collectionId))
    // {
    //   // path: [h, path.split(userId).pop()].join("/"),
    //   // serviceId: ctx.collectionId, //: "activity",
    // }));
  }, [path]);

  if (!userId) {
    return null;
  }

  if (!path) {
    return null;
  }

  return React.cloneElement(
    React.Children.only(children), {
      ...props,
      contextPath: path,
      activityList,
      itemsList,
      contact: contact || props.contact,
      onClose: clearActiveDetail,
    });
}

export default ContactActivityData;
